import { useCallback } from "react";

import { teamURLFilterType, IConsultantProfileURLFilter } from "@/data/consultant-profiles";
import { useToggle } from "@/hooks/Toggle";

export const useTeamFilters = (
  filterConfig: IConsultantProfileURLFilter,
  filterChangeHandler: (filter: any) => void,
) => {
  const [isFilterOpen, toggleFilterOpen] = useToggle(false);

  const handleFiltersChange = useCallback(
    (f: IConsultantProfileURLFilter = {}) => {
      if (f) {
        const filters = teamURLFilterType({ ...filterConfig, ...f });

        filterChangeHandler(filters);
      }
    },
    [filterConfig],
  );

  const clearFilters = useCallback(() => filterChangeHandler({}), [filterChangeHandler]);

  return {
    isFilterOpen,
    toggleFilterOpen,
    handleFiltersChange,
    clearFilters,
  };
};
